export default __webpack_public_path__ + "static/media/LinkedIn.b843b658.svg";